import { render, staticRenderFns } from "./RealityAutobuyerBox.vue?vue&type=template&id=2ee53d1b&scoped=true&"
import script from "./RealityAutobuyerBox.vue?vue&type=script&lang=js&"
export * from "./RealityAutobuyerBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee53d1b",
  null
  
)

export default component.exports